/* ––
 * ––– Imports
 * –––––––––––––––––––––––––––––––– */
import React, { forwardRef, useCallback } from 'react';

import CloseIcon from '@mui/icons-material/CloseRounded';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import { SnackbarContent, useSnackbar } from 'notistack';

/* ––
 * ––– Component
 * –––––––––––––––––––––––––––––––– */
const HighlightNotification = forwardRef(({
  // eslint-disable-next-line react/prop-types
  id, message = '', title = '', style = {},
}, ref) => {
  /* –– Tools
   * –––––––––––––––––––––––––––––––– */
  const theme = useTheme();
  const { closeSnackbar } = useSnackbar();

  /* –– Handlers
   * –––––––––––––––––––––––––––––––– */
  const dismissNotification = useCallback(() => closeSnackbar(id), [id, closeSnackbar]);

  /* –– Render
   * –––––––––––––––––––––––––––––––– */
  return (
    <SnackbarContent ref={ref} style={style} data-testid="highlight-notification">
      <Box
        maxWidth={{ xs: '100%', sm: '100%', md: '400px' }}
        color="#000000"
        letterSpacing="0.17px"
        p={2}
        borderRadius={2}
        bgcolor={theme.palette.background.highlight}
        boxShadow={8}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center">
            <AutoAwesomeIcon sx={{ color: theme.palette.ai.dark, fontSize: '18px' }} />
            <Typography variant="body2" fontWeight="bold" ml={0.75} data-testid="highlight-notification-title">
              {title}
            </Typography>
          </Box>
          <IconButton size="small" onClick={dismissNotification} sx={{ marginTop: '-3px', marginRight: '-3px' }}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box>
          <Typography variant="body2" marginX={0.25} data-testid="highlight-notification-message">
            {message}
          </Typography>
        </Box>
      </Box>
    </SnackbarContent>
  );
});

/* ––
 * ––– Exports
 * –––––––––––––––––––––––––––––––– */
export default HighlightNotification;
